/**
 * PilotFooterContentContainer component.
 */
import styled from 'styled-components';
import withOpacity from '@shared/components/utils/hoc/withOpacity';

/**
 * Styled pilot footer content container.
 */
const PilotFooterContentContainer = styled.div``;

export default withOpacity(PilotFooterContentContainer);
